import { InjectionToken } from '@angular/core';

/**
 * This URL is called by the MmuUserService to retrieve the current user login information.
 * It's provider defaults to "/api/userInfo", but likely has to be changed in every vertical.
 */
export const MMU_USER_INFO_ENDPOINT = new InjectionToken<string>('UserInfoEndpointUrl');
